import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};
export const ContentBox = ({ className = '', children }: Props) => (
  <div className={`rounded-sm p-lg bg-level-02 ${className}`}>{children}</div>
);

ContentBox.displayName = 'ContentBox';
